export default __webpack_public_path__ + "static/media/dia4.7b2e9a8b.png";